// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  background: #f6fcf9;
  border-radius: 8px;
}

.description {
  font-weight: 400;
  text-align: center;
  font-size: 14px;
  line-height: 120%;
}

button {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/shared/locker/locker-billet/locker-billet.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[":host {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  background: #f6fcf9;\n  border-radius: 8px;\n}\n\n.description {\n  font-weight: 400;\n  text-align: center;\n  font-size: 14px;\n  line-height: 120%;\n}\n\nbutton {\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
